import React, { useEffect, useState } from 'react';

type LoadingProps = {
    className?: string;
    textClassName?: string;
    iconClassName?: string;
    iconChildClassName?: string;
    hideMessage?: boolean;
    message?: string;
};

const Loading = ({
    className,
    textClassName,
    iconClassName,
    iconChildClassName,
    hideMessage,
    message,
}: LoadingProps) => {
    const [loadingMessage, setLoadingMessage] = useState('Loading...');
    useEffect(() => {
        if (message) {
            return;
        }

        const timeout = setTimeout(() => {
            setLoadingMessage('Still loading...');
        }, 10000);

        return () => clearTimeout(timeout);
    }, []);

    return (
        <div className={className}>
            <div className={`lds-ring ${iconClassName}`}>
                <div className={iconChildClassName} />
                <div className={iconChildClassName} />
                <div className={iconChildClassName} />
                <div className={iconChildClassName} />
                <div className={iconChildClassName} />
                <div className={iconChildClassName} />
                <div className={iconChildClassName} />
                <div className={iconChildClassName} />
                <div className={iconChildClassName} />
                <div className={iconChildClassName} />
                <div className={iconChildClassName} />
                <div className={iconChildClassName} />
            </div>
            {!hideMessage && (
                <span className={`ml-2 text-gray-500 ${textClassName}`}>
                    {message || loadingMessage}
                </span>
            )}
        </div>
    );
};

export default Loading;
